module.exports = __webpack_public_path__ + "static/media/close-white.232c42ce.svg";